// extracted by mini-css-extract-plugin
export default {"tablist":"TabList_tablist__m4b3y"};